(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function padNumber(number) {
      return String(number).padStart(2, '0');
    }

    function setText(element, value) {
      if (element) {
        element.textContent = value;
      }
    }

    function setupCountdown(timer) {
      if (!timer || timer.dataset.psReady === 'true') {
        return;
      }

      timer.dataset.psReady = 'true';

      var endValue = timer.getAttribute('data-end');
      var expiredMessage = timer.getAttribute('data-expired') || 'This offer has ended.';
      var endTime = new Date(endValue).getTime();
      var daysElement = timer.querySelector('[data-countdown-days]');
      var hoursElement = timer.querySelector('[data-countdown-hours]');
      var minutesElement = timer.querySelector('[data-countdown-minutes]');
      var secondsElement = timer.querySelector('[data-countdown-seconds]');
      var statusElement = timer.querySelector('[data-countdown-status]');

      if (!endValue || Number.isNaN(endTime)) {
        timer.classList.add('is-invalid');
        setText(statusElement, 'Add a valid timer date in the theme editor.');
        return;
      }

      function updateTimer() {
        var now = new Date().getTime();
        var distance = endTime - now;

        if (distance <= 0) {
          timer.classList.add('is-expired');
          setText(statusElement, expiredMessage);
          window.clearInterval(timerInterval);
          return;
        }

        var days = Math.floor(distance / 86400000);
        var hours = Math.floor((distance % 86400000) / 3600000);
        var minutes = Math.floor((distance % 3600000) / 60000);
        var seconds = Math.floor((distance % 60000) / 1000);

        setText(daysElement, padNumber(days));
        setText(hoursElement, padNumber(hours));
        setText(minutesElement, padNumber(minutes));
        setText(secondsElement, padNumber(seconds));
      }

      updateTimer();
      var timerInterval = window.setInterval(updateTimer, 1000);
    }

    function initCountdowns(root) {
      var scope = root || document;
      var timers = scope.querySelectorAll('[data-ps-countdown]');
      timers.forEach(setupCountdown);
    }

    document.addEventListener('DOMContentLoaded', function () {
      initCountdowns(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initCountdowns(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
